import queueMicrotask from 'queue-microtask';

declare global {
  interface Window {
    queueMicrotask?: (cb: () => void) => void;
  }
}

if (typeof window !== 'undefined' && typeof window.queueMicrotask !== 'function') {
  window.queueMicrotask = queueMicrotask;
}
